export const menuLinks = [
    { text: "home", path: "/" },
    { text: "work", path: "/work" },
    { text: "about", path: "/about" },
    { text: "contact", path: "/contact" },
];
